module.exports = __webpack_public_path__ + "static/CodeRegister-a00a8fde5681f82acff620fcf897f9ba.mp4";